"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRole = exports.saveAuthResource = exports.getRoleAllList = exports.getDataScopeDeptIdsByRoleId = exports.getAuthPowerListByRoleId = exports.deleteRoleById = exports.deleteBatchRoleById = exports.addRole = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加角色
 * @param role
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addRole = exports.addRole = function addRole(role) {
  return _api.default.request({
    url: '/system/role/save',
    method: 'post',
    data: role
  });
};

/**
 * 修改角色
 * @param role
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateRole = exports.updateRole = function updateRole(role) {
  return _api.default.request({
    url: '/system/role/update',
    method: 'post',
    data: role
  });
};

/**
 * 删除角色
 * @param roleId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteRoleById = exports.deleteRoleById = function deleteRoleById(roleId) {
  return _api.default.request({
    url: '/system/role/delete',
    method: 'post',
    params: {
      id: roleId
    }
  });
};

/**
 * 批量删除角色
 * @param roleIds
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchRoleById = exports.deleteBatchRoleById = function deleteBatchRoleById(roleIds) {
  return _api.default.request({
    url: '/system/role/deleteBatch',
    method: 'post',
    data: roleIds
  });
};

/**
 * 获取角色列表
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getRoleAllList = exports.getRoleAllList = function getRoleAllList() {
  return _api.default.request({
    url: '/system/role/all'
  });
};

/**
 * 根据角色id查询已授权的权限列表
 * @param roleId
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getAuthPowerListByRoleId = exports.getAuthPowerListByRoleId = function getAuthPowerListByRoleId(roleId) {
  return _api.default.request({
    url: '/system/role/getAuthPowerListByRoleId',
    params: {
      roleId: roleId
    }
  });
};

/**
 * 保存授权权限
 * @param roleResourceDto
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var saveAuthResource = exports.saveAuthResource = function saveAuthResource(roleResourceDto) {
  return _api.default.request({
    url: '/system/role/saveAuthResource',
    method: 'post',
    data: roleResourceDto
  });
};

/**
 * 获取已授权的数据范围部门ids
 * @param roleId
 * @returns {AxiosPromise}
 */
var getDataScopeDeptIdsByRoleId = exports.getDataScopeDeptIdsByRoleId = function getDataScopeDeptIdsByRoleId(roleId) {
  return _api.default.request({
    url: '/system/role/getDataScopeDeptIdsByRoleId',
    params: {
      roleId: roleId
    }
  });
};